import { Database } from "lucide-react";

const NoDataFound = () => {
  return (
    <>
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
          border: "1px solid #dee2e6",
          height: "40vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
        }}
      >
        <Database size={48} />
        <p>No Data Found</p>
      </div>
    </>
  );
};

export default NoDataFound;
